"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatableWidgets = exports.RepeatableWidgetsLegacy = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const GroupContent_1 = require("../../GroupContent");
const nestable_1 = require("../../nestable");
const RepeatableWidgetsLegacy = (ctx) => {
    return t.array((0, GroupContent_1.GroupItemLegacy)(ctx));
};
exports.RepeatableWidgetsLegacy = RepeatableWidgetsLegacy;
const RepeatableWidget = t.tuple([
    t.string,
    t.union([nestable_1.NestableContent, GroupContent_1.GroupContent]),
]);
const RepeatableWidgetsBlock = t.strict({
    __TYPE__: t.literal(GroupContent_1.GroupItemContentType),
    value: t.array(RepeatableWidget),
});
exports.RepeatableWidgets = t.array(RepeatableWidgetsBlock);
